// Multi-lingual WhatsApp templates for order updates.
// {name} = customer name, {id} = order id, {status} = current status label,
// {amount} = grand total ₹, {date} = ISO or friendly date

const T = {
  en: {
    quotation: "Namaste {name}, please find attached your quotation *{id}* — total ₹{amount}. Reply APPROVE to confirm.\n— Brothers Advertising",
    confirmed: "Namaste {name}, your order *{id}* is confirmed. We'll keep you posted at every step.\n— Brothers Advertising",
    design: "Hello {name}, our designer is working on your order *{id}*. We'll share the artwork for approval soon.\n— Brothers Advertising",
    printing: "Great news {name}! Your order *{id}* is now in printing.\n— Brothers Advertising",
    finishing: "Hi {name}, your order *{id}* is in the finishing stage.\n— Brothers Advertising",
    ready: "Ready to collect! Order *{id}* is packed and ready. We'll dispatch shortly.\n— Brothers Advertising",
    out_for_delivery: "Your order *{id}* is out for delivery. It will reach you soon.\n— Brothers Advertising",
    delivered: "Delivered! Thank you for choosing Brothers Advertising. Order *{id}*.",
    payment_due: "Hi {name}, a friendly reminder — balance ₹{amount} is due on order *{id}*.\n— Brothers Advertising",
    invoice: "Hi {name}, please find your invoice for *{id}* — total ₹{amount}.\n— Brothers Advertising",
  },
  hi: {
    quotation: "नमस्ते {name}, आपका कोटेशन *{id}* संलग्न है — कुल ₹{amount}. पुष्टि हेतु APPROVE भेजें.\n— Brothers Advertising",
    confirmed: "नमस्ते {name}, आपका ऑर्डर *{id}* कन्फर्म हो गया है. हम आपको हर चरण पर सूचित करते रहेंगे.\n— Brothers Advertising",
    design: "नमस्ते {name}, हमारा डिज़ाइनर आपके ऑर्डर *{id}* पर काम कर रहा है. जल्द ही अप्रूवल के लिए डिज़ाइन भेजेंगे.\n— Brothers Advertising",
    printing: "खुशख़बरी {name}! आपका ऑर्डर *{id}* अब प्रिंटिंग में है.\n— Brothers Advertising",
    finishing: "नमस्ते {name}, आपके ऑर्डर *{id}* का फिनिशिंग कार्य चल रहा है.\n— Brothers Advertising",
    ready: "तैयार है! ऑर्डर *{id}* पैक हो चुका है. जल्द ही डिस्पैच होगा.\n— Brothers Advertising",
    out_for_delivery: "आपका ऑर्डर *{id}* डिलीवरी के लिए निकल चुका है. जल्द पहुंचेगा.\n— Brothers Advertising",
    delivered: "डिलीवर हो गया! Brothers Advertising को चुनने के लिए धन्यवाद. ऑर्डर *{id}*.",
    payment_due: "नमस्ते {name}, यह एक स्मरण है — ऑर्डर *{id}* पर ₹{amount} शेष राशि बाकी है.\n— Brothers Advertising",
    invoice: "नमस्ते {name}, आपके ऑर्डर *{id}* का इनवॉइस — कुल ₹{amount}.\n— Brothers Advertising",
  },
  mr: {
    quotation: "नमस्कार {name}, तुमचे कोटेशन *{id}* सोबत जोडले आहे — एकूण ₹{amount}. पुष्टीसाठी APPROVE पाठवा.\n— Brothers Advertising",
    confirmed: "नमस्कार {name}, तुमची ऑर्डर *{id}* कन्फर्म झाली आहे. प्रत्येक टप्प्यावर आम्ही अपडेट देत राहू.\n— Brothers Advertising",
    design: "नमस्कार {name}, आमचा डिझायनर तुमच्या ऑर्डर *{id}* वर काम करत आहे. लवकरच मंजुरीसाठी डिझाईन पाठवू.\n— Brothers Advertising",
    printing: "छान बातमी {name}! तुमची ऑर्डर *{id}* आता प्रिंटिंगमध्ये आहे.\n— Brothers Advertising",
    finishing: "नमस्कार {name}, तुमच्या ऑर्डर *{id}* चे फिनिशिंग सुरू आहे.\n— Brothers Advertising",
    ready: "तयार आहे! ऑर्डर *{id}* पॅक झाली आहे. लवकरच पाठवली जाईल.\n— Brothers Advertising",
    out_for_delivery: "तुमची ऑर्डर *{id}* डिलिव्हरीसाठी निघाली आहे. लवकरच पोहोचेल.\n— Brothers Advertising",
    delivered: "डिलिव्हरी झाली! Brothers Advertising ला निवडल्याबद्दल धन्यवाद. ऑर्डर *{id}*.",
    payment_due: "नमस्कार {name}, स्मरण — ऑर्डर *{id}* वर ₹{amount} शिल्लक आहे.\n— Brothers Advertising",
    invoice: "नमस्कार {name}, तुमच्या ऑर्डर *{id}* चे इनव्हॉइस — एकूण ₹{amount}.\n— Brothers Advertising",
  },
};

export const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "hi", label: "हिंदी" },
  { code: "mr", label: "मराठी" },
];

const STATUS_TO_TEMPLATE = {
  inquiry: "quotation",
  quotation: "quotation",
  confirmed: "confirmed",
  design: "design",
  cust_approval: "design",
  design_approved: "design",
  printing: "printing",
  finishing: "finishing",
  quality_check: "ready",
  packing: "ready",
  ready: "ready",
  out_for_delivery: "out_for_delivery",
  delivered: "delivered",
  completed: "delivered",
};

function fill(template, vars) {
  return template.replace(/\{(\w+)\}/g, (_, k) => (vars[k] != null ? String(vars[k]) : ""));
}

function pickLang(lang) {
  return T[lang] ? lang : "en";
}

export function statusTemplate({ lang = "en", status, name, id, amount }) {
  const l = pickLang(lang);
  const key = STATUS_TO_TEMPLATE[status] || "confirmed";
  return fill(T[l][key] || T.en[key], { name, id, amount });
}

export function templateByKey(key, { lang = "en", name, id, amount }) {
  const l = pickLang(lang);
  return fill(T[l][key] || T.en[key], { name, id, amount });
}

export function buildWaLink(phone, message) {
  const digits = (phone || "").replace(/\D/g, "");
  const num = digits.length === 10 ? `91${digits}` : digits;
  return `https://wa.me/${num}?text=${encodeURIComponent(message)}`;
}

// Small helper: persist last picked language in localStorage
const KEY = "wa_lang";
export function getSavedLang() {
  try { return localStorage.getItem(KEY) || "en"; } catch { return "en"; }
}
export function saveLang(l) {
  try { localStorage.setItem(KEY, l); } catch { /* ignore quota errors */ }
}
